import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import moment from 'moment';
import { v4 } from 'uuid';

class homeSpecialOfferStore {

    // Properties

    @observable specialOffers = [];
    @observable specialOfferId = 0;
    @observable taskId = 0;
    @observable taskName = '';

    @observable title = '';
    @observable titleEnglish = '';
    @observable titleChinese = '';
    @observable titleChineseTraditional = '';
    @observable titleThai = '';
    @observable titleJapanese = '';
    @observable titleVietnamese = '';

    @observable briefDesc = '';
    @observable briefDescEnglish = '';
    @observable briefDescChinese = '';
    @observable briefDescChineseTraditional = '';
    @observable briefDescThai = '';
    @observable briefDescJapanese = '';
    @observable briefDescVietnamese = '';

    @observable description = '';
    @observable descriptionEnglish = '';
    @observable descriptionChinese = '';
    @observable descriptionChineseTraditional = '';
    @observable descriptionThai = '';
    @observable descriptionJapanese = '';
    @observable descriptionVietnamese = '';

    @observable price = 0;
    @observable originalPrice = 0;
    @observable imageUrl = '';
    @observable images = [];
    @observable startDate = undefined;
    @observable endDate = undefined;
    @observable showBannerOnly = false;
    @observable sort = 1;

    @observable homeSpecialOfferLoading = false;

    @action init() {
        this.specialOffers = [];

        return ApiCaller.SpecialOffer.GetAll().then((specialOfferResponses) => {
            if (specialOfferResponses) {
                specialOfferResponses.map((item) => {
                    item.startDate = moment(item.startDate).format("DD MMMM YYYY");
                    item.endDate = moment(item.endDate).format("DD MMMM YYYY");

                    return item;
                })

                this.specialOffers = specialOfferResponses;
            }
        })
    }

    @action initAvailable() {
        return ApiCaller.SpecialOffer.GetAllAvailable().then((specialOfferResponses) => {
            if (specialOfferResponses) {
                specialOfferResponses.map((item) => {
                    item.startDate = moment(item.startDate).format("DD MMMM YYYY");
                    item.endDate = moment(item.endDate).format("DD MMMM YYYY");

                    return item;
                })

                this.specialOffers = specialOfferResponses;
            }
        });
    }

    @action initRead(specialOfferId) {
        this.imageUrl = '';

        return ApiCaller.SpecialOffer.GetById(specialOfferId).then((specialOfferResponse) => {
            if (specialOfferResponse) {
                this.specialOfferId = specialOfferResponse.specialOfferId;
                this.taskId = specialOfferResponse.taskId;
                this.taskName = specialOfferResponse.taskName;

                this.briefDesc = specialOfferResponse.briefDesc;
                this.briefDescEnglish = specialOfferResponse.briefDescLang.english;
                this.briefDescChinese = specialOfferResponse.briefDescLang.chinese;
                this.briefDescChineseTraditional = specialOfferResponse.briefDescLang.chineseTraditional;
                this.briefDescThai = specialOfferResponse.briefDescLang.thai;
                this.briefDescJapanese = specialOfferResponse.briefDescLang.japanese;
                this.briefDescVietnamese = specialOfferResponse.briefDescLang.vietnamese;

                this.description = specialOfferResponse.description;
                this.descriptionEnglish = specialOfferResponse.descriptionLang.english;
                this.descriptionChinese = specialOfferResponse.descriptionLang.chinese;
                this.descriptionChineseTraditional = specialOfferResponse.descriptionLang.chineseTraditional;
                this.descriptionThai = specialOfferResponse.descriptionLang.thai;
                this.descriptionJapanese = specialOfferResponse.descriptionLang.japanese;
                this.descriptionVietnamese = specialOfferResponse.descriptionLang.vietnamese;

                this.title = specialOfferResponse.title;
                this.titleEnglish = specialOfferResponse.titleLang.english;
                this.titleChinese = specialOfferResponse.titleLang.chinese;
                this.titleChineseTraditional = specialOfferResponse.titleLang.chineseTraditional;
                this.titleThai = specialOfferResponse.titleLang.thai;
                this.titleJapanese = specialOfferResponse.titleLang.japanese;
                this.titleVietnamese = specialOfferResponse.titleLang.vietnamese;

                this.price = specialOfferResponse.price;
                this.originalPrice = specialOfferResponse.originalPrice;
                this.imageUrl = specialOfferResponse.imageUrl || '';
                this.images = [];
                if (specialOfferResponse.imageUrl) {
                    try {
                        let imagesJson = JSON.parse(specialOfferResponse.imageUrl);
                        imagesJson.map(imageJson => {
                            return imageJson.isLoading = false;
                        });
                        this.images = imagesJson;
                    } catch {
                        this.images.push({
                            id: v4(),
                            url: specialOfferResponse.imageUrl,
                            isLoading: false
                        });
                    }
                }

                this.startDate = moment(specialOfferResponse.startDate).format("DD MMMM YYYY");
                this.endDate = moment(specialOfferResponse.endDate).format("DD MMMM YYYY");

                this.showBannerOnly = specialOfferResponse.showBannerOnly;
                this.sort = specialOfferResponse.sort;
            }
        })
    }

    @action setHomeSpecialOfferLoading(value) {
        this.homeSpecialOfferLoading = value;
    }

    @action resetData() {
        this.images = [];
        this.imageUrl = '';
        this.title = '';
        this.titleEnglish = '';
        this.titleChinese = '';
        this.titleChineseTraditional = '';
        this.titleThai = '';
        this.titleJapanese = '';
        this.titleVietnamese = '';

        this.description = '';
        this.descriptionEnglish = '';
        this.descriptionChinese = '';
        this.descriptionChineseTraditional = '';
        this.descriptionThai = '';
        this.descriptionJapanese = '';
        this.descriptionVietnamese = '';
    }
}

export default new homeSpecialOfferStore()